import axiosInstance from "global/helpers/axiosInstance";
import {
  LABORDENDIGITAL_SUCCESS,
  LABORDENDIGITAL_LOADING,
  LABORDENDIGITAL_ERROR,
  LABORDENDIGITAL_RESET,
  LABORDENDIGITAL_ALTATURNO_SET,
  LABORDENDIGITAL_LOAD,
  LABORDENDIGITAL_FLGVOLVER,
  LABORDENDIGITAL_MEDICO_ORIG_SOLICITANTE,
  LABORDENDIGITAL_FECHA_SET,
} from "../../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

/* export const wsGetLabOrdenDigital = (idPacFamiliar, nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get(`/LabOrdenDigital/GetByIdPaciente/${idPacFamiliar}`)
      .then((res) => {
        dispatch({
          type: LABORDENDIGITAL_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error.detail);
      });
  });
}; */
export const wsGetLabOrdenDigital = (idPacFamiliar, nextStep) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`lis/laboratorio/ordendigital/GetByIdPaciente/${idPacFamiliar}`)
      .then((res) => {
        dispatch({
          type: LABORDENDIGITAL_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: LABORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, error.detail);
      });
  });
};

export const setLoadingOrdenDigital = (loading) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_LOAD,
    payload: loading,
  });
};

export const setAltaTurnoOrdenDigital = (ordenDigital) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_ALTATURNO_SET,
    payload: ordenDigital,
  });
};

export const setFlgVolverOrdenDigital = (flgVolver) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_FLGVOLVER,
    payload: flgVolver,
  });
};

export const resetLabOrdenDigital = () => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_RESET,
  });
};

export const setMedicoOrigSolicitante = (codigo) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_MEDICO_ORIG_SOLICITANTE,
    payload: codigo,
  });
};

// Fecha de la orden de labo (fechaalta) para arrancar la búsqueda de turnos desde esa
// fecha y validar al confirmar que el turno no sea anterior.
export const setFechaOrdenLabDigital = (fecha) => (dispatch) => {
  dispatch({
    type: LABORDENDIGITAL_FECHA_SET,
    payload: fecha,
  });
};
